import { CompanyState } from "./Company";
import { SimpleUser } from "./Users";

export type CompanyLifecycleEvent = {
  id: string,
  eventType: CompanyLifecycleEventType,
  fromState: CompanyState,
  toState: CompanyState,
  createdAt: string,
  actor: SimpleUser,
  reason: string | null,
}

export type CompanyLifecycleEventType = "CREATED" | "CHANGED_STATE"; // | "UPDATED";

export const CompanyLifecycleEventTypeValues: Record<CompanyLifecycleEventType, string> = {
  CREATED: "Skapade företaget",
  CHANGED_STATE: "Ändrade status",
  // UPDATED: "Uppdaterade",
};
